<nav class="navbar navbar-expand px-2">
    <div class="side-nav-button p-2 me-3" (click)="sideNavToggle()">
        <i class="fa-solid fa-bars"></i>
    </div>
    <div class="brand-logo">
        <img src="assets/ather-logo6-dark.png" alt="Aether HRMS">
    </div>

    <div class="navbar-collapse">
    </div>
    <div class="profilw-logo">
        <div class="row col-12">
            <div class="col-10 user-name" align="right">
                <span class="col-12">{{userFullName}} </span>
            </div>
            <div class="col-2">
                <div class="col-12 btn-group" (hide.bs.dropdown)="onProfileMenuClose()">
                    <button type="button" class="profile-menu-button fa-solid fa-user-pen fa-xl"
                        data-bs-toggle="dropdown" aria-label="Open profile menu"
                        style="border: none; background: transparent;">
                    </button>

                    <ul class="dropdown-menu mt-2">
                        <li><a class="dropdown-item" (click)="profileView()">Profile</a></li>
                        <li>
                            <hr class="dropdown-divider">
                        </li>

                        <li class="dropdown-submenu" [class.submenu-open]="isThemeMenuOpen">
                            <button type="button"
                                class="dropdown-item dropdown-toggle d-flex justify-content-between align-items-center"
                                (click)="$event.stopPropagation(); toggleThemeMenu()">
                                Theme
                            </button>

                            <ul class="dropdown-menu submenu-side" [class.show-menu]="isThemeMenuOpen">
                                <li>
                                    <button type="button"
                                        class="dropdown-item theme-selector theme-default d-flex justify-content-between align-items-center"
                                        (click)="setTheme('default')">
                                        <span>Default theme</span>
                                        @if (currentTheme === 'default') { <i
                                            class="fa-solid fa-check text-primary ms-2"></i> }
                                    </button>
                                </li>
                                <li>
                                    <button type="button"
                                        class="dropdown-item theme-selector theme-alternate d-flex justify-content-between align-items-center"
                                        (click)="setTheme('alternate')">
                                        <span>Alternate theme</span>
                                        @if (currentTheme === 'alternate') { <i
                                            class="fa-solid fa-check text-primary ms-2"></i> }
                                    </button>
                                </li>
                                <li>
                                    <button type="button"
                                        class="dropdown-item theme-selector theme-sunset d-flex justify-content-between align-items-center"
                                        (click)="setTheme('sunset')">
                                        <span>Sunset theme</span>
                                        @if (currentTheme === 'sunset') { <i
                                            class="fa-solid fa-check text-primary ms-2"></i> }
                                    </button>
                                </li>
                                <li>
                                    <button type="button"
                                        class="dropdown-item theme-selector theme-midnight d-flex justify-content-between align-items-center"
                                        (click)="setTheme('midnight')">
                                        <span>Midnight theme</span>
                                        @if (currentTheme === 'midnight') { <i
                                            class="fa-solid fa-check text-primary ms-2"></i> }
                                    </button>
                                </li>
                                <li>
                                    <button type="button"
                                        class="dropdown-item theme-selector theme-corporate d-flex justify-content-between align-items-center"
                                        (click)="setTheme('corporate')">
                                        <span>Corporate theme</span>
                                        @if (currentTheme === 'corporate') { <i
                                            class="fa-solid fa-check text-primary ms-2"></i> }
                                    </button>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <hr class="dropdown-divider">
                        </li>
                        <li><a class="dropdown-item" href="#" (click)="logOut()">Logout</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</nav>